import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';

@Component({
  selector: 'app-makepwd',
  templateUrl: './makepwd.component.html'
})
export class MakepwdComponent implements OnInit {
  senhaEnviada: boolean;
  logotipo: string;
  public processando: boolean;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  constructor(public mainService: MainService,
    public location: LocationStrategy,
    public router: Router) {
    if (this.mainService.loginService.subject === undefined) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.mainService.http.pathApi().get(this.getLogo())
      .subscribe(data => {
        this.logotipo = data.url;
      });
  }

  public getLogo() {
    let parametro = undefined;
    const local = this.location.path();
    let location = (<any>this.location)._platformLocation.location.href;
    location = location.replace(local, '');
    if (location === 'www.picpontos.com.br' || location === 'picpontos.com.br' || location === 'homolog.picpontos.com.br') {
      if (this.mainService.sessionService !== undefined && this.mainService.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.mainService.sessionService.getClientUuid();
      } else {
        parametro = '?type=context&content=' + location.split('/')[3];
      }
    } else {
      if (this.mainService.sessionService !== undefined && this.mainService.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.mainService.sessionService.getClientUuid();
      } else {
        parametro = '?type=domain&content=' + location + '/';
      }
    }
    return 'clientes/logotipo/' + parametro;
  }

  makePwd() {
    if (this.mainService.loginService.subject.communicationCode === undefined) {
      this.bootboxAlertComId.alerta('Informe o Código de Comunicação');
    } else {
      this.processando = true;
      this.mainService.http.pathV2().post('login/password/create/', this.mainService.loginService.subject, true)
        .subscribe(
          sucesso => {
            this.senhaEnviada = true;
            this.mainService.loginService.subject = undefined;
            this.processando = false;
          }, erro => {
            this.processando = false;
            this.bootboxAlertComId.alerta(erro._body);
          }
        );
      this.mainService.loginService.subject.communicationCode = undefined;
    }
  }

  public goToLogin() {
    this.senhaEnviada = false;
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// ./src/app/public/makepwd/makepwd.component.ts